import { EEntity } from '../enums/entity.enum';
import { IEntity } from '@/shared/interfaces/entity.interface';

export const searchEntityMapper = <T extends Record<string, any>>(
  data: T,
  type: EEntity,
  phone: string,
): IEntity => {
  const emails = [
    ...new Set(
      [
        data.emailaddress1,
        data.emailaddress2,
        data.emailaddress3,
        data.internalemailaddress,
      ].filter(Boolean),
    ),
  ];

  switch (type) {
    case EEntity.ACCOUNT: {
      const phones = [
        ...new Set([data.telephone1, data.telephone2].filter(Boolean)),
      ];

      return {
        id: data.accountid,
        fullName: data.name,
        initialPhone: phone ?? phones[0],
        phone: data.telephone1,
        secondPhone: data.telephone2,
        emails,
        type: EEntity.ACCOUNT,
        phones,
      };
    }

    case EEntity.CONTACT: {
      const phones = [
        ...new Set([data.telephone1, data.mobilephone].filter(Boolean)),
      ];

      return {
        id: data.contactid,
        fullName: data.fullname,
        initialPhone: phone ?? phones[0],
        phone: data.telephone1,
        secondPhone: data.mobilephone,
        emails,
        type: EEntity.CONTACT,
        phones,
      };
    }

    case EEntity.LEAD: {
      const phones = [
        ...new Set([data.telephone1, data.mobilephone].filter(Boolean)),
      ];

      return {
        id: data.leadid,
        fullName: data.fullname,
        initialPhone: phone ?? phones[0],
        phone: data.telephone1,
        secondPhone: data.mobilephone,
        emails,
        type: EEntity.LEAD,
        phones,
      };
    }

    case EEntity.SYSTEM_USER: {
      const phones = [
        ...new Set(
          [data.address1_telephone1, data.mobilephone].filter(Boolean),
        ),
      ];

      return {
        id: data.systemuserid,
        fullName: data.fullname,
        initialPhone: phone ?? phones[0],
        phone: data.mobilephone,
        secondPhone: data.address1_telephone1,
        emails,
        type: EEntity.SYSTEM_USER,
        phones,
      };
    }
  }
};
